import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import i18n from '../../config/i18n';
import { FileAPIConnectors } from '../../api/index';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
  PATIENT_ID,
} from '../../constants/RoleConstants';

const styles = {
  table: {
    marginBottom: 0,
  },
  thead: {
    backgroundColor: '#FFFFF5',
    color: '#2D3E4F',
  },
  th: {
    fontSize: 18,
  },
  edit: {
    float: 'right',
  },
  imgWrapper: {
    display: 'inline-block',
  },
  imgText: {
    textAlign: 'center',
  },
  imgStyle: {
    marginLeft: 10,
    marginRight: 10,
    display: 'inline',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: 200,
    verticalAlign: 'middle',
  },
  hidden: {
    display: 'none',
  },
};

class WoundPhotoDiary extends Component {
  constructor(props) {
    super(props);
    const { photos } = this.props;
    this.state = {
      showPhotos: false,
      photos,
      photoUrlFetched: false,
    };
    this.toggle = this.toggle.bind(this);
    this.uploadWoundPhoto = this.uploadWoundPhoto.bind(this);
  }

  componentDidMount() {
    const { photos } = this.state;

    // Fetch presigned urls for photos
    const promises = photos.map(photo => this.getPreSignedUrl(photo));
    Promise.all(promises).then((values) => {
      const photosWithUrl = [];
      values.forEach((value, idx) => {
        photosWithUrl.push({ ...photos[idx], preSignedUrls: value });
      });
      this.setState({
        photos: photosWithUrl,
        photoUrlFetched: true,
      });
    });
  }

  getPreSignedUrl = photo => FileAPIConnectors.getPhotoDownloadURL(`assessments/${this.props.id}/photos/${photo.id}`)

  uploadWoundPhoto() {
    const {
      origin,
      pathname,
    } = window.location;

    // If the current user is a patient, we need to change the current base
    // url /records/:id to /medical-records/:id
    const path = /medical-records/i.test(pathname)
      ? pathname
      : pathname.replace('records', 'medical-records');

    window.location.href = `${origin}${path}/wounds/${this.props.woundId}/assessment/${this.props.id}/photo-upload`;
  }

  toggle() {
    this.setState({ showPhotos: !this.state.showPhotos });
  }

  canUploadWoundPhoto() {
    return [
      DOCTOR_ID,
      ASSISTANT_ID,
      NURSE_ID,
      PATIENT_ID,
    ].indexOf(this.props.user.profile.roleId) > -1;
  }

  handleImageClick = async (photo) => {
    const newPresignedlink = await this.getPreSignedUrl(photo);
    window.location.href = newPresignedlink;
  }

  renderPhotos(photos) {
    const photoUrls = this.state.photoUrlFetched ? photos.map(photo => photo.preSignedUrls) : [];
    const { imgStyle, imgWrapper, imgText } = styles;
    return photoUrls.map((url, idx) => (
      <li key={url} style={imgWrapper} className="woundImg">
        <a download onClick={() => this.handleImageClick(photos[idx])}>
          <img
            style={imgStyle}
            src={url}
            alt={i18n.t('woundAssessment')}
            className="img-rounded img-responsive center-block"
          />
        </a>
        <div style={imgText}>
          {i18n.t('clickToDownload')}
        </div>
      </li>
    ));
  }

  render() {
    const {
      table,
      thead,
      th,
      edit,
    } = styles;
    const {
      photos,
      showPhotos,
    } = this.state;

    const photoUrlsByDate = _.groupBy(photos, a => moment(a.created).format('YYYY-MM-DD'));
    const photoDiary = [];
    Object.keys(photoUrlsByDate).forEach((key) => {
      photoDiary.push(
        <tr key={key}>
          <td colSpan="2">
            <div>Date: {key}</div>
            <ul id="imgrow">
              {this.renderPhotos(photoUrlsByDate[key])}
            </ul>
          </td>
        </tr>
      );
    });

    return (
      <table
        className="table table-bordered table-responsive"
        style={table}
      >
        <thead style={thead}>
          <tr>
            <th style={th}>
              {i18n.t('woundPhotosDiary')}
              <span style={edit}>
                {
                  this.canUploadWoundPhoto() ? (
                    <button
                      className="btn btn-sm btn-success"
                      onClick={this.uploadWoundPhoto}
                    >
                      {i18n.t('upload')}
                    </button>
                  ) : null
                }
                <button
                  className="btn btn-sm btn-primary"
                  onClick={this.toggle}
                >
                  {i18n.t(showPhotos ? 'collapse' : 'expand')}
                </button>
              </span>
            </th>
          </tr>
        </thead>
        <tbody style={showPhotos ? {} : styles.hidden}>
          {photoDiary}
        </tbody>
      </table>
    );
  }
}

export default WoundPhotoDiary;



// WEBPACK FOOTER //
// ./src/components/patient/WoundPhotoDiary.js